import { shouldShowCounterparty } from "@common/helpers/counterparties";
import { Counterparty } from "@common/types/counterparty";
import { useCallback } from "react";

export function useShowCounterparty() {
    return useCallback(
        (
            counterparty?: Pick<
                Counterparty,
                | "workspaceId"
                | "updatedByUserId"
                | "source"
                | "shouldBeNormalized"
            > | null,
        ) =>
            counterparty && shouldShowCounterparty(counterparty, true)
                ? counterparty
                : null,
        [],
    );
}
